export default "__VITE_PUBLIC_ASSET__2adb0597__"